import Icons from "../../../../../shared/constants/icon.constant";
import Courses from "../pages/Courses";

const learningRoutes = {
  path: "learning",
  label: "Learning",
  icon: Icons.Learning({ width: 16, height: 16 }),
  children: [
    {
      path: "courses",
      label: "Courses",
      icon: Icons.Course({ width: 16, height: 16 }),
      element: <Courses />,
    },
  ],
};

export default learningRoutes;
